













import Vue from "vue";
import { Component } from "vue-property-decorator";
import Game, { GameType } from "@/components/Game.vue";
import views from "@/views/Views";

@Component({
  components: {
    Game,
  },
})
export default class WordsRemove extends Vue {
  type: GameType = GameType.WORDSREMOVE;
  title = views.find((el) => el.component === GameType.WORDSREMOVE).title;
  video = "wordsremove.mp4";
}
